var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('div',[_c('div',[_vm._v("Welcome to Ultromics Worklist")]),_c('button',{staticClass:"btn btn-secondary my-2 my-sm-0 float-right",on:{"click":_vm.login}},[_vm._v(" Log In ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }